export function employeeCharacteristicParagraphs(value) {
    const text = String(value || '')
        .replace(/\r\n?/g, '\n')
        .replace(/[\u2028\u2029]/g, '\n')
        .trim();

    if (!text) return [];

    return text
        .split(/\n[\t ]*\n+/)
        .map(paragraph => paragraph.trim())
        .filter(Boolean);
}
